import {Component, OnInit} from '@angular/core';
import {InterestService} from '../../services/interest.service';
import {environment} from '../../../environments/environment';
import {InterestRequest} from '../../model/interestRequest';
import {Pms} from '../../model/pms';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-interest-form',
  templateUrl: './interest-form.component.html',
  styleUrls: ['./interest-form.component.scss']
})
export class InterestFormComponent implements OnInit {

  busy = false;
  signedUp = false;
  showError = false;
  errorMessage = '';

  propertyName: string;
  propertyRooms: number;
  propertyUrl: string;
  propertyAddress: string;
  propertyStart: string;
  propertyPms: string = null;

  otherPms: string = null;

  contactName: string;
  contactRole: string;
  contactEmail: string;
  contactPhone: string;

  approveTermsAndConditions = false;

  internalUse = false;
  salesPerson: string;
  clientNotes: string;
  isPaying: boolean;

  captchaResponse: string;

  pmsList: Array<Pms> = [];

  atomizeTips: Array<string> = [
    'Atomize optimizes your prices holistically across all room types',
    'Atomize automatically monitors your competitors',
    'Atomize can run on full automation',
    'Atomize uses the latest innovations in machine learning and AI',
    'Atomize analyzes search patterns in your booking engine'
  ];
  atomizeTipsIndex = 0;
  currentAtomizeTip = this.atomizeTips[this.atomizeTipsIndex];

  private readonly internalUseParameterName = 'intuse';
  private readonly internalUseParameterValidValue = 'sWe6lreTrigA';

  constructor(private interestService: InterestService, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.loadPmsList();

    this.activatedRoute
      .queryParamMap
      .subscribe(params => {
        if (params.get(this.internalUseParameterName)) {
          const internalUseParameter = params.get(this.internalUseParameterName);
          if (internalUseParameter && internalUseParameter === this.internalUseParameterValidValue) {
            this.internalUse = true;
          }
        }
      });
  }

  getStageLabel() {
    return environment.stageLabel;
  }

  checkForEnter(event) {
    if (event.keyCode === 13 && !event.shiftKey) {
      // Stop propagation to just allow the new line to be added to the text
      event.stopPropagation();
    }
  }

  loadPmsList() {
    this.interestService.getAvailablePmsList().subscribe(
        data => {
          this.pmsList = data.pmsList;
        }
    );
  }

  onSubmit() {
    this.busy = true;
    this.interestService.sendInterestRequest(
      this.buildSignupRequest()
    ).subscribe(
      response => {
        if (response.success === true) {
          this.showError = false;
          this.signedUp = true;
          this.busy = false;
        } else {
          this.errorMessage = response.message;
          this.showError = true;
          this.signedUp = false;
          this.busy = false;
        }
      },
      error => {
        this.errorMessage = 'Unexpected error when signing up.';
        this.showError = true;
        this.signedUp = false;
        this.busy = false;
      }
    );
  }

  nextAtomizeTip() {
    this.atomizeTipsIndex++;
    if (this.atomizeTipsIndex >= this.atomizeTips.length) {
      this.atomizeTipsIndex = 0;
    }

    this.currentAtomizeTip = this.atomizeTips[this.atomizeTipsIndex];
  }

  private buildSignupRequest(): InterestRequest {
    const request = new InterestRequest();
    request.propertyName = this.propertyName;
    request.propertyRooms = this.propertyRooms;
    request.propertyUrl = this.propertyUrl;
    request.propertyAddress = this.propertyAddress;
    request.propertyStart = this.propertyStart;
    if (this.propertyPms === 'other') {
      request.propertyPmsName = this.otherPms;
      request.propertyPms = null;
    } else {
      request.propertyPmsName = this.propertyPms;
      request.propertyPms = this.pmsList.find(p => p.name === this.propertyPms).key;
    }
    request.contactName = this.contactName;
    request.contactRole = this.contactRole;
    request.contactEmail = this.contactEmail;
    request.contactPhone = this.contactPhone;

    if (this.internalUse) {
      request.salesPerson = this.salesPerson;
      request.clientNotes = this.clientNotes;
      if (this.isPaying) {
        request.invoiceType = 1; // Manual invoice type
        request.paymentState = 1; // Successful payment state
      } else {
        request.invoiceType = null;
        request.paymentState = null;
      }
    }

    request.termsAndConditionsApproved = this.approveTermsAndConditions;

    return request;
  }
}



// WEBPACK FOOTER //
// /Users/linusvaltersson/AtomizeSource/clean_web/atomize-interest/src/app/components/interest-form/interest-form.component.ts